class megaCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const menuTabs = [...this.querySelectorAll(".mm-tab")]; // Selecting mm-tab based on the class
    menuTabs.forEach((tab) => {
      tab.addEventListener("mouseenter", (e) => this.switchTab(e));
    });
  }

  switchTab(e) {
    const currentTabLink = this.querySelector(".mm-tab.active");
    if (currentTabLink) currentTabLink.classList.remove("active");

    e.target.classList.add("active");
    const tabId = e.target.id;
    const tabContent = this.querySelector(`.${tabId}`);
    const currentTab = this.querySelector(".mm-tab-content:not([hidden])");

    if (currentTab && tabContent) {
      currentTab.setAttribute("hidden", "");
      tabContent.removeAttribute("hidden");
    }
  }
}

customElements.define("mega-collections", megaCollections);

function copyCouponCode(element) {
  // Get the coupon code from the data-coupon attribute
  const couponCode = element.getAttribute("data-coupon");

  // Create a temporary input element to copy the coupon code to the clipboard
  const tempInput = document.createElement("input");
  document.body.appendChild(tempInput);
  tempInput.value = couponCode;

  // Select the text inside the input element
  tempInput.select();
  tempInput.setSelectionRange(0, 99999); // For mobile devices

  // Execute the copy command
  document.execCommand("copy");

  // Remove the temporary input element
  document.body.removeChild(tempInput);

  // Optionally alert the user that the coupon code has been copied
  alert("Coupon Code Copied: " + couponCode);
}
